export default __webpack_public_path__ + "static/media/document_logo.8bf5f818.png";